import type { IConfigComponents } from '@yimoka/react';
import { components as reactComponents } from '@yimoka/react';

import { Trans } from '@/locales/i18n';


export const components: IConfigComponents = {
  ...reactComponents,
  Trans,
} as unknown as IConfigComponents;
